import {
  useSiteContext,
  useTranslations,
  useUserSettings,
} from '@dustin-web/microsite-components/src/hooks'
import Link from 'next/link'

const ReviewsPolicyLink = () => {
  const { translate } = useTranslations()
  const { sourcingCompany } = useSiteContext()
  const { language } = useUserSettings()
  const isNL = sourcingCompany === 'NL'
  const nlPolicyLink = translate('Review_Policy_Link_B2B_NL_ENG')
  const policyLink =
    isNL && language === 'English'
      ? nlPolicyLink
      : translate('Review_Policy_Link_B2B')

  return (
    <aside>
      <Link
        className="u-mb-0"
        aria-label={translate('Review_Policy_Link_Aria_Label')}
        target="_blank"
        href={policyLink}
        rel="noopener noreferrer"
        style={{
          color: '#000000cc',
          textDecoration: 'underline #000000cc',
          fontSize: '14px',
        }}>
        {translate('Review_Policy_Link_Text')}
      </Link>
    </aside>
  )
}

export default ReviewsPolicyLink
